// Content for Intervantis Transport Solutions clone (user's own website content)

export const company = {
  name: 'Intervantis Transport Solutions GmbH',
  tagline: 'Logistics Powered By Engineering',
  address: ['Bei den Mühren 1', '20457 Hamburg', 'Germany'],
  phone: '+49 173 6378445',
  emails: ['dominik@intervantis.com', 'operations@intervantis.com'],
  linkedin: 'https://www.linkedin.com/company/intervantis-transport-solutions-gmbh/',
  instagram: 'https://www.instagram.com/intervantisgmbh',
  mapQuery: 'Bei den Mühren 1, 20457 Hamburg, Germany'
};

export const navTabs = [
  { id: 'introduction', label: 'Introduction' },
  { id: 'capabilities', label: 'Services' },
  // { id: 'process', label: 'Process' },   // temporarily hidden — uncomment to re-enable
  { id: 'expertise', label: 'Expertise' },
  { id: 'projects', label: 'Projects' },
  // { id: 'global', label: 'Global' },      // temporarily hidden — uncomment to re-enable
  { id: 'contact', label: 'Contact' }
];

export const hero = {
  headlineLead: 'Engineered Confidence in every ',
  headlineAccent: 'Transport Operation.',
  sub: "Advanced transport engineering, heavy-lift solutions, marine transportation studies and project cargo consultancy for the world's most challenging logistics projects.",
  images: [
    '/brand/hero-crane.jpg',
    '/brand/hero-towers.jpg',
    '/brand/hero-blades.jpg',
    '/brand/hero-reactor.jpg',
    '/brand/hero-propeller.jpg',
    '/brand/marshalling.jpg'
  ]
};

export const stats = [
  { value: '20+', label: 'Years combined experience in intermodal transport engineering & survey' },
  { value: '500+', label: 'Supervised transhipment operations' },
  { value: '1,500+', label: 'Tailored method statements for project cargo' },
  { value: '100%', label: 'Customer satisfaction' }
];

export const introduction = {
  index: '00',
  label: 'Introduction',
  headingLead: 'Logistics Powered ',
  headingAccent: 'By Engineering.',
  paragraphs: [
    '“Moving Project Cargo” may sound easy — but is it really? When handling requirements become complex, logistics expertise alone is no longer enough. Industrial project cargo often involves oversized dimensions, extreme weights, challenging lifting arrangements, transport restrictions and operational constraints that must be understood long before execution begins.',
    'At Intervantis Transport Solutions, we bridge the gap between logistics planning and operational reality. From initial feasibility studies to on-site supervision, we develop engineered approaches that turn technical complexity into workable strategies.',
    'Whether you are planning to ship your precious cargo in a container, on a flatrack or as break bulk via truck, heavy-lift vessel or barge — our team supports you with the technical expertise and operational experience needed to deliver your project with confidence.'
  ],
  quote: 'Our mission is simple: to eliminate uncertainty and help our clients deliver safe, efficient and commercially viable transport solutions anywhere in the world.',
  cta: 'Meet the team',
  gallery: [
    { src: '/brand/speicherstadt.jpg', tag: 'Hamburg · Speicherstadt' },
    { src: '/brand/speicherstadt-sunset.jpg', tag: 'Hamburg · Sunset' },
    { src: '/brand/speicherstadt-night.jpg', tag: 'Hamburg · Night' },
    { src: 'https://images.unsplash.com/photo-1782218284505-4fd25f180b10?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400', tag: 'Hamburg · Elbphilharmonie' },
    { src: 'https://images.unsplash.com/photo-1778774918701-da0b02b5625a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400', tag: 'Hamburg · HafenCity' },
    { src: 'https://images.unsplash.com/photo-1767250752542-26f218107359?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400', tag: 'Hamburg · Harbour Dusk' },
    { src: 'https://images.unsplash.com/photo-1769776208566-ac17d0b9e955?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400', tag: 'Hamburg · Port at Dusk' },
    { src: 'https://images.unsplash.com/photo-1741376659226-aa43dd378019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400', tag: 'Hamburg · Container Terminal' },
    { src: 'https://images.pexels.com/photos/34926604/pexels-photo-34926604.jpeg?auto=compress&cs=tinysrgb&w=1400', tag: 'Hamburg · Eurogate Terminal' },
    { src: 'https://images.pexels.com/photos/29278107/pexels-photo-29278107.jpeg?auto=compress&cs=tinysrgb&w=1400', tag: 'Hamburg · Container Cranes' }
  ],
  galleryCaption: "Speicherstadt, Hamburg — UNESCO World Heritage and Europe's largest historic warehouse district."
};

export const team = {
  label: 'Intervantis · People',
  title: 'Meet the Team',
  meta: '3 Engineers · Hamburg',
  sectionTitle: 'Our Team',
  intro: 'A small, senior team of transport engineers and marine surveyors. We work hands-on with our clients from first feasibility study to on-site execution — and we are proud of how lean and focused that keeps us.',
  members: [
    { no: '01', initials: 'DS', photo: '/brand/team/dominik.jpg', photoFull: '/brand/team/dominik-full.jpg', name: 'Dominik M. Schäfer', role: 'Managing Director', email: 'dominik@intervantis.com', bio: 'Being the owner & MD of Intervantis Transport Solutions GmbH fills me with endless pleasure! This position combines the physically demanding and rather harsh environment in project cargo ports and on board various vessel types or deck barges with the convenient office atmosphere during ops planning phases, engineering, team-meetings, business development etc.\n\nAfter my studies of Nautical Science in Elsfleth, Germany I spent several years at sea before taking on a position as Marine Surveyor during which I specialized in the planning and supervision of intermodal project cargo transports as well as cargo and vessel inspections. Before founding the company in 2021, I lived and worked four years in the USA where I was lucky to extend my knowledge on logistics planning, tender management, marshalling support for large scale projects and barge offshore transportation.\n\nMy position requires a deep understanding of national and international statutory provisions, legal frameworks, client and corporate policies, the latest technology advancements and a lot of good seamanship. I am a highly skilled and very experienced Marine Transport Engineer and have gained exceptional knowledge in the handling of heavy project cargoes throughout the last two decades.' },
    { no: '02', initials: 'SB', photo: '/brand/team/stefan.jpg', photoFull: '/brand/team/stefan-full.jpg', name: 'Stefan Bursch', role: 'Transport Engineer · Marine Cargo Surveyor', email: 'stefan@intervantis.com', bio: 'As a Transport Engineer and Marine Cargo Surveyor at Intervantis Transport Solutions GmbH, I am responsible for planning complex loading operations and providing professional supervision during their execution.\n\nMy expertise is built on twelve years of seagoing experience, during which I served aboard various general cargo vessels. This gave me extensive hands-on experience with a wide range of cargo types, loading procedures, and transport-related challenges.\n\nAfter my career at sea, I decided to apply this knowledge ashore and pursue a new professional path as a Marine Cargo Surveyor. Today, I combine my practical seafaring experience with technical transport expertise to plan and supervise even complex loading operations safely, efficiently, and with a strong focus on practical solutions.' },
    { no: '03', initials: 'AS', photo: '/brand/team/akhil.jpg', photoFull: '/brand/team/akhil-full.jpg', name: 'Akhil M S', role: 'Transport Engineer', email: 'akhil@intervantis.com', bio: 'As a Marine Transport Engineer at Intervantis Transport Solutions GmbH, I transform complex cargo movements into precise, validated engineering solutions. I specialise in developing complex lift plans and detailed 3D stowage and securing plans, utilising CAD modelling and engineering analysis to visualise, assess and validate each operation before execution.\n\nI perform lifting, rigging and cargo-securing calculations in accordance with recognised standards, including the IMO CSS Code and DNV rules. By combining advanced 3D engineering tools with practical engineering judgement, I develop safe, efficient and technically robust solutions tailored to the specific requirements of each operation.' }
  ]
};


export const services = {
  index: '01',
  label: 'Services',
  headingLead: 'One Engineering Partner. ',
  headingMuted: 'Every Stage Of The Transport.',
  body: 'Our mission at Intervantis Transport Solutions GmbH is to deliver turn-key project cargo transportation solutions founded on engineering, structured planning, and responsible execution. We support complex projects from feasibility and surveys through equipment sourcing, logistics planning, and coordinated delivery. We value technical clarity, realistic concepts, and respect for operational risk. Every solution we develop is shaped by careful analysis, transparent methods, and practical constraints. Our vision is to grow as a trusted engineering-led partner in project cargo transportation — contributing to safer projects, more efficient outcomes, and a continuously evolving industry.',
  items: [
    { no: '01', slug: 'intermodal-transport-engineering', title: 'Intermodal Transport Engineering', desc: 'Complete technical method statements incl. cargo handling analysis, stowage plans, grillage design, seafastening and risk-assessments.' },
    { no: '02', slug: 'heavy-lift-engineering', title: 'Heavy-Lift Engineering', desc: 'Crane selection, lift plans and rigging design for challenging cargoes.' },
    { no: '03', slug: 'marine-survey-port-captain-services', title: 'Marine Survey & Port Captain Services', desc: 'Supervision of handling activities during loading and discharging ops (vessel / barge / container / truck etc.) incl. inspections of cargo condition, rigging materials and seafastening.' },
    { no: '04', slug: 'equipment-labor-sourcing', title: 'Equipment & Labor Sourcing', desc: 'Cranes & rigging equipment; weight spread material & fabricated grillage; specialized personnel (riggers, stevedores, welders, NDT inspectors etc.).' },
    { no: '05', slug: 'integrated-port-services', title: 'Integrated Port Services', desc: 'Marshalling Support for large-scale projects (Strategic Coordination & Supervision & Quality Control), Specialized Equipment and Documentation.' }
  ]
};

export const process = {
  index: '03',
  label: 'Method',
  headingLead: "The 4 E’s of ",
  headingAccent: 'Excellence.',
  body: 'From early project assessment to final execution, our Marine Survey and Engineering teams provide the technical insight, practical experience and on-site support required for the safe and efficient transportation of project cargo.',
  steps: [
    { no: '01', title: 'Engage', desc: 'We engage at an early stage to understand the cargo, transport route, operational requirements and project-specific constraints. Close coordination with clients, carriers, terminals and other stakeholders creates a clear technical basis for all subsequent decisions.' },
    { no: '02', title: 'Evaluate', desc: 'We evaluate cargoes, transport assets, handling arrangements and operational interfaces through surveys, inspections and technical feasibility studies. Potential risks and limitations are identified before they affect the operation.' },
    { no: '03', title: 'Engineer', desc: 'We develop practical and technically sound solutions for lifting, stowage, load distribution and cargo securing. Our engineering combines calculations, drawings and method statements with the realities of terminal, vessel and transport operations.' },
    { no: '04', title: 'Execute', desc: 'We support the execution on site through experienced Marine Surveyors and Port Captains. By monitoring cargo handling, verifying compliance with approved procedures and coordinating with all involved parties, we help ensure that the operation is carried out safely and as planned.' }
  ]
};

export const expertise = {
  index: '05',
  label: 'Capabilities',
  headingLead: "What we're actually ",
  headingAccent: 'good at.',
  body: "Services give you the big picture — this is where we get specific. Below is the actual hands-on work our engineers and surveyors roll up their sleeves for week in, week out: the calculations, the inspections, the on-quay coordination and the late-night problem-solving that keep complex cargo moving safely. If something's on this list, odds are we've done it dozens of times over, in ports all over the world. And if what you need isn't here? Ask us anyway — the tricky, one-of-a-kind moves are exactly the ones we enjoy most.",
  industriesLabel: 'Industries we serve',
  industriesIndex: '06',
  industries: [
    'Renewables (OEMs / Developers)', 'EPCIs', 'Logistics Companies', 'Shipping Companies', 'Insurance Companies', 'Manufacturers', 'Consignees'
  ],
  capabilities: [
    'Cargo Inspections and Damage Surveys',
    'Container Inspections (Damage / Stuffing / Securing)',
    'Flatrack & OOG Cargo Inspections',
    'Technical Method Statements',
    'Stowage Plans (Deck Layout; Crane Outreach etc.)',
    'Heavy-Lift Engineering',
    'Deck Strength Analysis & Grillage Design',
    'Finite Element Analysis (FEA)',
    'Seafastening (IMO CSS; DNVGL-ST-N001)',
    'Marshalling Support',
    'Tender Support',
    'Risk Assessments',
    'Technical Consulting',
    'Equipment Sourcing'
  ]
};

export const projects = {
  index: '07',
  label: 'Selected Work',
  headingLead: 'Engineered movements. ',
  headingMuted: 'Documented outcomes.',
  body: 'A selection of recent project cargo, heavy-lift and marine engineering executions. These are just a few highlights — our team has delivered 1,500+ method statements and hundreds of surveys and supervisions worldwide. Select a project to open the full case file.',
  // `featured: true` renders a large hero tile in the gallery.
  items: [
    {
      no: '01',
      slug: 'osb-project-mv-rudolf',
      title: 'OSB Project – M/V Rudolf',
      featured: true,
      img: '/brand/osb/osb2.jpg',
      gallery: [
        '/brand/osb/osb2.jpg',
        '/brand/osb/osb4.webp',
        '/brand/osb/osb1.jpg',
        '/brand/osb/osb5.jpg',
        '/brand/osb/osb3.webp'
      ],
      region: 'Bremen → Alabama',
      scope: 'Marine Cargo Survey | Loading Supervision | Stowage & Securing',
      client: 'Conceptum Logistics Hamburg GmbH',
      year: '2026',
      location: 'Bremen, Germany – Neustädter Hafen | Port Theodore, Alabama, USA',
      vessel: 'M/V Rudolf – Voyage 2604',
      cargo: 'OSB Final Board Cutting Line | 91 Wooden Cases | 4 Breakbulk Skids | 123 Containers',
      metric: '218',
      metricLabel: 'Cases · skids · containers',
      facts: [
        'Pre-loading inspection and condition survey of project cargo',
        'Supervision of lifting, rigging, loading and positioning operations for wooden cases, containers and flatracks',
        'Inspection of timber shoring, blocking and cargo securing arrangements',
        'Technical coordination with vessel crew, Port Captain, stevedores and attending surveyors',
        'Identification and documentation of packing damage and handling deficiencies'
      ]
    },
    {
      no: '02',
      slug: 'agnico-eagle-mine-odyssey-cargo-survey',
      title: 'Agnico Eagle Mine Odyssey – Cargo Survey',
      img: '/brand/agnico/case.webp',
      gallery: [
        '/brand/agnico/render.webp',
        '/brand/agnico/case.webp',
        '/brand/agnico/strapped.webp',
        '/brand/agnico/lashing-calc.png'
      ],
      region: 'Hamburg, Germany',
      scope: 'Marine Cargo Survey | Loading Supervision | Stowage & Securing | Cargo Securing Calculation',
      client: 'Conceptum Logistics Hamburg GmbH',
      year: '2026',
      location: 'Hamburg, Germany',
      project: 'Agnico Eagle Mine Odyssey',
      cargo: '4 × Brake Stands | 1 × Lifting Device | 1 × Tool Case',
      metric: '6',
      metricLabel: 'Wooden Cases · 4 Flatracks',
      facts: [
        'Pre-loading inspection of cargo and 40-ft flatracks',
        'Supervision of lifting, positioning and loading operations',
        'Verification of cargo condition and load distribution',
        'Supervision of timber blocking, anti-sliding arrangements and cargo lashing',
        'Technical verification of lashing materials and securing capacities',
        'Coordination with packing contractor and handling personnel',
        'Final inspection and documentation of cargo securing arrangements'
      ]
    },
    {
      no: '03',
      slug: 'rolls-royce-v20-generators-cargo-survey',
      title: 'Rolls-Royce V20 Generators – Cargo Survey',
      img: '/brand/rr/wrapped.jpg',
      gallery: [
        '/brand/rr/render1.png',
        '/brand/rr/render2.png',
        '/brand/rr/forklift.jpg',
        '/brand/rr/wrapped.jpg',
        '/brand/rr/container.webp'
      ],
      region: 'Passau & Hamburg',
      scope: 'Marine Cargo Survey | Road Transport | Container Stuffing | Stowage & Securing',
      client: 'Hanseatic Freight Contor GmbH',
      year: '2025',
      location: 'Passau & Hamburg, Germany',
      project: 'Colo4 – Penske1',
      cargo: '5 × Rolls-Royce V20 Generators | 5 × Accessory Boxes',
      metric: '5',
      metricLabel: 'Generators · 40-ft HC Containers',
      facts: [
        'Condition survey of five Rolls-Royce V20 generators prior to transportation',
        'Supervision of loadout onto semi-trailers in Passau',
        'Inspection of road transport equipment and cargo securing arrangements',
        'Supervision of container stuffing at EPOLOG, Hamburg',
        'Inspection of 40-ft HC containers and purpose-built timber support structures',
        'Supervision of generator positioning, timber shoring and cargo securing',
        'Verification of lashing and anti-sliding arrangements',
        'Final inspection and sealing of containers prior to delivery to the container terminal'
      ]
    },
    {
      no: '04',
      slug: 'siemens-arkansas-nuclear-one-marine-cargo-survey',
      title: 'Siemens Arkansas Nuclear One – Marine Cargo Survey',
      img: '/brand/siemens/s1.webp',
      gallery: [
        '/brand/siemens/s1.webp',
        '/brand/siemens/s2.webp',
        '/brand/siemens/s3.webp',
        '/brand/siemens/s4.webp',
        '/brand/siemens/s5.webp',
        '/brand/siemens/orion1.webp',
        '/brand/siemens/orion2.webp',
        '/brand/siemens/orion3.webp'
      ],
      region: 'Mülheim → Antwerp',
      scope: 'Marine Cargo Survey | Heavy Lift Supervision | Loading | Discharge | Stowage & Securing',
      client: 'UTC Overseas GmbH',
      year: '2025',
      location: 'Mülheim, Germany · Antwerp, Belgium',
      project: 'Arkansas Nuclear One',
      vessel: 'MS Avena · MV BBC Orion',
      cargo: '33 Siemens Project Cargo Packages | Turbine Rotors · Upper/Lower Parts · Wooden Cases',
      metric: '33',
      metricLabel: 'Project Cargo Packages',
      facts: [
        'Condition inspection of project cargo prior to handling',
        'Supervision of loadout onto inland vessel MS Avena',
        'Monitoring of discharge operations at Katoen Natie Terminal, Antwerp',
        'Supervision of heavy-lift operations and rigging arrangements',
        'Monitoring of loading onto MV BBC Orion',
        'Inspection of cargo stowage, sea-fastening, lashing and welded stoppers',
        'Supervision of hot-work and final securing arrangements',
        'Verification of lifting equipment, working loads and cargo handling procedures'
      ]
    },
    {
      no: '05',
      slug: 'zomet-generators-mv-eastern-rock',
      title: 'Zomet Generators – M.V. Eastern Rock',
      img: '/brand/fidelio/f1.webp',
      gallery: [
        '/brand/fidelio/f1.webp',
        '/brand/fidelio/f2.webp',
        '/brand/fidelio/f3.webp',
        '/brand/fidelio/f4.webp',
        '/brand/fidelio/f5.jpg'
      ],
      region: 'Hamburg → Ashdod',
      scope: 'Marine Cargo Survey | Loadout Engineering | Loadout Supervision | Stowage & Securing | Sea Fastening | Hot Work Inspection',
      client: 'UTC Overseas GmbH',
      year: '2021',
      location: 'Hamburg, Germany – Wallmann Terminal · Ashdod, Israel',
      project: 'Zomet · Ref. 820-17',
      vessel: 'M.V. Eastern Rock – Voyage 2021-19 · IMO 9857119',
      cargo: '2 × Generators | 184.6 t each | 10.36 × 4.97 × 4.49 m (wooden cases)',
      metric: '369.2 t',
      metricLabel: 'Combined weight of both generators',
      facts: [
        'Condition inspection of the vessel, cargo, stowage and securing arrangements prior to loading',
        'Supervision of the loadout of two 184.6 t generators onto M.V. Eastern Rock',
        'Supervision of generator positioning onto elevating supports and HEB 180 load-spreading beams',
        'Verification of cargo securing using 96 × 98 kN MSL chain lashings',
        'Inspection of welded steel stoppers and D-rings, verified by an independent weld inspector',
        'Monitoring of hatch-cover panels stacked to bridge and protect the cargo',
        'Confirmation of weather protection with tarpaulins closing all gaps',
        'Visual inspection of all lashings and weld seams',
        'Verification of compliance with the approved Marine Transportation Manual and method statement'
      ]
    },
    {
      no: '06',
      slug: 'siemens-revolution-wind-mv-eemslift-nelli',
      title: 'Siemens “Revolution Wind” – M.V. Eemslift Nelli',
      img: '/brand/nelli/n1.webp',
      gallery: [
        '/brand/nelli/n1.webp',
        '/brand/nelli/n2.webp',
        '/brand/nelli/n3.webp',
        '/brand/nelli/n4.webp',
        '/brand/nelli/n5.webp'
      ],
      region: 'Hamburg, Germany',
      scope: 'Marine Cargo Survey | Pre-Survey | Heavy Lift Supervision | Loadout | Stowage & Lashing | Sea Fastening | Hot Work Inspection',
      client: 'UTC Overseas GmbH',
      year: '2025',
      location: 'Hamburg, Germany – Wallmann Terminal',
      vessel: 'M.V. Eemslift Nelli – IMO 9671462',
      cargo: '39 × Siemens Project Cargoes | 2 × 208.1 t Generators | 2 × 53.6 t Rotor Cases | 35 × Wooden Cases',
      metric: '416 t+',
      metricLabel: 'Combined weight of the two generators and two rotor cases',
      facts: [
        'Pre-survey and condition inspection of 39 Siemens project cargoes prior to vessel loadout',
        'Supervision of discharge from Barge DBR4512A and assessment of heavy-lift rigging methodology',
        'Monitoring of cargo condition, including investigation of water ingress observed at one generator package',
        'Supervision of tandem lifting of 2 × 208.1 t generators using two Liebherr LHM600 harbour cranes',
        'Inspection and verification of certified lifting beams, wire grommets, shackles, chains and soft slings',
        'Supervision of loading and positioning of generators, rotor cases and wooden cases into the vessel’s lower hold and tween-deck',
        'Inspection of approximately 60 welded steel sea-fastening stoppers',
        'Verification of cargo securing using steel stoppers, timber shoring, web lashings and chain lashings',
        'Inspection and monitoring of hot-work and welding activities during sea-fastening installation',
        'Verification of vessel stability, cargo hold readiness, lifting equipment, PPE and operational procedures',
        'Coordination and supervision involving the vessel crew, terminal, Siemens and UTC representatives',
        'Final inspection confirming all 39 cargo packages were loaded, stowed and secured without reported handling incidents or non-conformities'
      ]
    },
    {
      no: '07',
      slug: 'siemens-energia-2000-manzanillo-mv-ym-amazon',
      title: 'Siemens “Energia 2000 Manzanillo” – M/V YM AMAZON',
      img: '/brand/energia/e1.webp',
      gallery: [
        '/brand/energia/e1.webp',
        '/brand/energia/e2.webp',
        '/brand/energia/e3.webp'
      ],
      region: 'Avilés, Spain',
      scope: 'Marine Cargo Survey | Pre-Loading Inspection | Tandem Heavy Lift | Loadout | Stowage & Lashing | Sea Fastening | Hot Work Inspection',
      client: 'UTC Overseas, Inc.',
      year: '2025',
      location: 'Avilés, Spain – Terminal Marítima de Avilés',
      project: 'Energia 2000 Manzanillo',
      vessel: 'M/V YM AMAZON – Voyage 03-2025',
      cargo: '2 × Siemens E-Houses (Shelters) | E10UBA22-PTA & E10UBA23-UPS',
      metric: '65.4 t',
      metricLabel: 'Combined cargo weight',
      facts: [
        'Pre-loading condition inspection of 2 Siemens E-Houses prior to vessel loadout',
        'Supervision of tandem heavy lifting using 2 × Liebherr LHM400G harbour cranes, each with 120 t WLL',
        'Inspection and verification of lifting arrangements comprising flat web slings and 17 t WLL shackles',
        'Monitoring of controlled tandem lifting to prevent differential loading on individual slings and lifting points',
        'Supervision of cargo positioning in Cargo Hold No. 1 of M/V YM AMAZON',
        'Verification of anti-sliding arrangements using 9 rolls of rubber mats beneath each E-House',
        'Inspection of 24 welded D-rings and associated sea-fastening arrangements',
        'Verification of 12 × 13 mm long-link chains per E-House, each with 98 kN lashing capacity',
        'Inspection of welding quality, including approximately 5 mm average throat thickness',
        'Supervision and inspection of hot-work and cargo-securing activities',
        'Verification of vessel readiness, cargo hold condition, lifting equipment, PPE and operational procedures',
        'Coordination with the vessel’s Chief Officer, Port Captain and stevedoring team throughout the operation',
        'Both E-Houses were successfully loaded, secured and inspected without incidents or handling non-conformities'
      ]
    }
  ]
};

export const globalSection = {
  index: '08',
  label: 'Global',
  headingLead: 'From Hamburg. ',
  headingMuted: 'To every port.',
  sub: 'Ports, marine routes and logistics corridors actively engaged worldwide.',
  // lat/lng drive exact placement on the world map; desc + img power the detail popup
  ports: [
    { name: 'Hamburg', country: 'Germany', flag: '🇩🇪', hq: true, lat: 53.5511, lng: 9.9937, desc: "Our home port and headquarters. One of Europe's largest container ports and the engineering hub for every Intervantis project.", img: 'https://images.unsplash.com/photo-1590496793907-4d66e2994b4d?w=1200&q=80' },
    { name: 'Rotterdam', country: 'Netherlands', flag: '🇳🇱', lat: 51.9500, lng: 4.1400, desc: 'Largest seaport in Europe and a primary deep-water gateway for oversized and heavy-lift project cargo.', img: 'https://images.pexels.com/photos/31445085/pexels-photo-31445085.jpeg?auto=compress&cs=tinysrgb&w=1200' },
    { name: 'Antwerp', country: 'Belgium', flag: '🇧🇪', lat: 51.2600, lng: 4.4000, desc: 'Major breakbulk and project cargo hub with extensive heavy-lift terminal capacity and strong inland connectivity.', img: 'https://images.pexels.com/photos/36652827/pexels-photo-36652827.jpeg?auto=compress&cs=tinysrgb&w=1200' },
    { name: 'Houston', country: 'United States', flag: '🇺🇸', lat: 29.7500, lng: -95.0700, desc: 'Key US Gulf gateway for energy, refinery and petrochemical module transport and oversized cargo.', img: 'https://images.unsplash.com/photo-1606185540834-d6e7483ee1a4?w=1200&q=80' },
    { name: 'Singapore', country: 'Singapore', flag: '🇸🇬', lat: 1.2900, lng: 103.8500, desc: 'Central transshipment hub for Asia-Pacific project cargo, heavy-lift and marine logistics operations.', img: 'https://images.unsplash.com/photo-1721559032993-3f09cf25a386?w=1200&q=80' },
    { name: 'Jebel Ali (Dubai)', country: 'United Arab Emirates', flag: '🇦🇪', lat: 25.0100, lng: 55.0600, desc: "The Middle East's largest port and a strategic staging base for EPC and energy project cargo.", img: 'https://images.unsplash.com/photo-1721559033545-664f8c8647dc?w=1200&q=80' },
    { name: 'Shanghai', country: 'China', flag: '🇨🇳', lat: 30.6260, lng: 122.0650, desc: "World's busiest container port and a primary origin for manufactured project components and modules.", img: 'https://images.unsplash.com/photo-1606964212858-c215029db704?w=1200&q=80' },
    { name: 'Santos', country: 'Brazil', flag: '🇧🇷', lat: -23.9600, lng: -46.3300, desc: 'Largest port in Latin America and the main gateway for South American project and renewables cargo.', img: 'https://images.unsplash.com/photo-1691591765923-3bd6f12f4209?w=1200&q=80' },
    { name: 'Durban', country: 'South Africa', flag: '🇿🇦', lat: -29.8700, lng: 31.0300, desc: 'Busiest port in Sub-Saharan Africa. Primary gateway for African project logistics, mining equipment and offshore-related cargo.', img: 'https://images.pexels.com/photos/33587048/pexels-photo-33587048.jpeg?auto=compress&cs=tinysrgb&w=1200' },
    { name: 'Fremantle (Perth)', country: 'Australia', flag: '🇦🇺', lat: -32.0500, lng: 115.7400, desc: "Western Australia's principal port serving mining, resources and offshore energy project cargo.", img: 'https://images.pexels.com/photos/24702866/pexels-photo-24702866.jpeg?auto=compress&cs=tinysrgb&w=1200' }
  ]
};

export const contactInfo = {
  index: '09',
  label: 'Contact',
  heading: 'Engineer your next move.',
  sub: 'Send project specifics, route notes or scope. Our engineers reply personally.',
  formLabel: 'Project Inquiry'
};

export const footerData = {
  blurb: 'Engineering-led project cargo transportation, heavy-lift engineering, marine survey, equipment sourcing and intermodal logistics — from Hamburg to the world.',
  services: [
    'Intermodal Transport Engineering', 'Heavy-Lift Engineering', 'Marine Survey & Port Captain Services', 'Equipment & Labor Sourcing', 'Integrated Port Services'
  ],
  industries: [
    'Renewables (OEMs / Developers)', 'EPCIs', 'Logistics Companies', 'Shipping Companies', 'Insurance Companies', 'Manufacturers'
  ],
  legal: ['Privacy Policy', 'Terms & Conditions', 'Impressum'],
  copyright: '© 2026 Intervantis Transport Solutions GmbH · All rights reserved'
};
